module.exports = __webpack_public_path__ + "images/d07806277afb6f5150031ab87db6f6011ae3f63fd4e4e845d1c3090b441f3193.svg";